import { render } from "./DropdownMenu.vue?vue&type=template&id=b93e2902&scoped=true&ts=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=b93e2902&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93e2902"]])

export default __exports__